export const normalizeParticipantIds = (ids: number[]) => {
  const uniqueIds = Array.from(new Set(ids)).filter((id) =>
    Number.isFinite(id),
  );
  uniqueIds.sort((a, b) => a - b);
  return uniqueIds;
};

export const buildParticipantIds = (
  participants: Array<{ id: number }>,
  currentUserId?: number,
  includeCurrentUser = true,
) => {
  const ids = participants.map((participant) => participant.id);
  if (includeCurrentUser && currentUserId && Number.isFinite(currentUserId)) {
    ids.push(currentUserId);
  }
  return normalizeParticipantIds(ids);
};
